import React, { useState } from 'react'
import { useDispatch, } from 'react-redux'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { dProductsSaveTemplateSagaAC } from 'model/dashboardProducts/dProductsActionCreators'

import { ButtonLink } from 'components/UI/ButtonLink/ButtonLink';
import { RadioGroupComponent, typeRadioGroupItem } from 'components/UI/RadioGroup/RadioGroup';
import {
    SelectStoresBlock
} from 'components/containers/dashboard/dataProducts/popupContents/popupExport/selectStoreBlock';
import {
    ImportFileBlock
} from 'components/containers/dashboard/dataProducts/popupContents/popupExport/importFileBlock';


export enum IMPORT_VARIANT {
    CATALOG = 'CATALOG',
    STORES = 'STORES',
    COMMON = 'COMMON'
}

// Type
export type typePopupImportProducts = {
    variant?: string
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}

// Component
export const PopupImportProducts: React.FC<typePopupImportProducts> = ({ variant, setOpenPopup }) => {

    const dispatch = useDispatch()


    // Select variant of import

    const variants: typeRadioGroupItem[] = [
        {
            id: IMPORT_VARIANT.COMMON,
            name: <Trans>As in the import file</Trans>,
            suggest: <Trans>As usual, with all data from the file</Trans>
        },
        {
            id: IMPORT_VARIANT.STORES,
            name: <Trans>In selected store(s)</Trans>,
            suggest: <Trans>You must select the store(s), stores from the file will be ignored</Trans>
        },
        {
            id: IMPORT_VARIANT.CATALOG,
            name: <Trans>To a catalog (list of products)</Trans>,
            suggest: <Trans>Store and price from the file will be ignored</Trans>
        },
    ]

    const [ importVariant, setImportVariant ] = useState(IMPORT_VARIANT.COMMON)


    //  select store
    const [ selectedStoresId, setSelectedStoresId ] = useState<string[]>([])
    const [ openBlockSelectStore, setOpenBlockSelectStore ] = useState(false)


    const onSaveTemplateClick = () => {
        dispatch(dProductsSaveTemplateSagaAC())
    }

    //  select file
    const [ openSelectFile, setOpenSelectFile ] = useState(false)
    const onSelectFileClick = (e: React.FormEvent) => {
        e.preventDefault()
        setOpenBlockSelectStore(false)
        setOpenSelectFile(true)
    }

    return (
        <>
            <div className={ 'flex flex-col gap-2 w-50vw' }>
                <div className={ 'text-right mb-1' }>
                    <ButtonLink
                        buttonClassName={ 'text-xs text-indigo-500 text-right hover:underline hover:text-indigo-600 focus:underline' }
                        type={ 'button' } label={ <Trans>Download template import file</Trans> }
                        onClick={ onSaveTemplateClick }/>
                </div>

                 <form className={ ( openSelectFile || openBlockSelectStore ) ? 'hidden' : 'visible' } >
                    <RadioGroupComponent
                        variant={ variant }
                        valuesList={ variants }
                        valueId={ importVariant }
                        setIdValue={ setImportVariant }
                        label={ <Trans>How do you want to make import ?</Trans> }
                    />
                    <div className="flex gap-4 mt-6 sm:mt-5 sm:flex sm:flex-row-reverse">
                        { importVariant === IMPORT_VARIANT.STORES
                            ? <Button type="submit"
                                      variant={ variant }
                                      label={ <Trans>Select stores</Trans> }
                                      onClick={ (e: React.FormEvent) => {e.preventDefault(); setOpenBlockSelectStore(true) }}
                            />

                            : <Button type="submit"
                                      variant={ variant }
                                      label={ <Trans>Select a file</Trans> }
                                      onClick={ onSelectFileClick }
                            />
                        }


                        <Button type="button" secondary={ true } label={ <Trans>Close</Trans> }
                                onClick={ () => setOpenPopup(false) }/>
                    </div>
                </form>

                <div className={openBlockSelectStore ? 'visible': 'hidden'}>
                    <SelectStoresBlock
                        setOpenBlock={ setOpenBlockSelectStore }
                        setSelectedStores={ setSelectedStoresId }
                        setOpenBlockSelectFile={ setOpenSelectFile }
                    />
                </div>

                { openSelectFile &&
                    <ImportFileBlock setOpenBlock={ setOpenSelectFile } setOpenPopup={ setOpenPopup }
                                     importVariant={ importVariant } selectedStoresIds={ selectedStoresId }
                                     setOpenSelectStoresBlock={setOpenBlockSelectStore }
                    />
                }

            </div>

        </>
    )
}
